module.exports = __webpack_public_path__ + "static/media/ARIALBI 1.b04eb000.TTF";